import { withStyles as tssWithStyles } from 'tss-react/mui';

const withStyles = (styles) => (Component) => tssWithStyles(Component, styles);
export default withStyles;
